import Vue from 'vue'
import user from '../../apis/user'
import dealer from '../../apis/dealer'
import site from '../../apis/site'
import common from '../../apis/common'
import {
  RESET_STATE,
  GET_MYPROFILE_REQUEST,
  GET_MYPROFILE_SUCCESS,
  GET_MYPROFILE_FAILURE,
  GET_MYDEALER_REQUEST,
  GET_MYDEALER_SUCCESS,
  GET_MYDEALER_FAILURE,
  GET_MYSITES_REQUEST,
  GET_MYSITES_SUCCESS,
  GET_MYSITES_FAILURE,
  SEND_EMAILCHANGE_EMAIL_REQUEST,
  SEND_EMAILCHANGE_EMAIL_SUCCESS,
  SEND_EMAILCHANGE_EMAIL_FAILURE,
  UPDATE_MYPROFILE_REQUEST,
  UPDATE_MYPROFILE_SUCCESS,
  UPDATE_MYPROFILE_FAILURE,
  CHANGE_MYPASSWORD_REQUEST,
  CHANGE_MYPASSWORD_SUCCESS,
  CHANGE_MYPASSWORD_FAILURE,
  UPLOAD_MYAVATAR_REQUEST,
  UPLOAD_MYAVATAR_SUCCESS,
  UPLOAD_MYAVATAR_FAILURE
} from '../mutation-types'

let initialState = {
  dealerTypeTextList: [
    'Security Integrator',
    'Full Service Integrator',
    'Wholesale Monitoring Station',
    'Security Dealer'
  ],
  myProfile: {
    userId: null,
    mqttAccessToken: null,
    email: null,
    firstName: null,
    lastName: null,
    created: null,
    // isToResetPassword: null, // TO BE DELETED
    isEmailVerified: null,
    profilePictureUrl: null,
    isAdmin: null
  },
  myDealer: {},
  mySites: [],
  myDevices: [],
  myAccessHistory: [],
  status: {
    getMyProfile: null,
    getMyDealer: null,
    getMySites: null,
    updateMyProfile: null,
    changeMyProfile: null,
    uploadMyAvatar: null,
    sendEmailChangeEmail: null
  }
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  myFirstName: function (state) {
    return state.myProfile.firstName ? state.myProfile.firstName : ''
  },
  myLastName: function (state) {
    return state.myProfile.lastName ? state.myProfile.lastName : ''
  },
  isValidAccount: function (state) {
    return state.myProfile.isEmailVerified
  },
  // isToResetPassword: function (state) { // TO BE DELETED
  //   return state.myProfile.isToResetPassword
  // },
  myMqttAccessToken: function (state) {
    return state.myProfile.mqttAccessToken
  },
  isCHeKTAdmin: function (state) {
    return state.myProfile.isAdmin
  },
  hasMyDealer: function (state) {
    return !!state.myDealer.dealerId
  },
  hasMySites: function (state) {
    return !!state.mySites.length
  },
  hasMyDevices: function (state) {
    return !!state.myDevices.length
  },
  hasMyAccessHistory: function (state) {
    return !!state.myAccessHistory.length
  },
  myDealer: function (state) {
    return state.myDealer
  },
  myDealerId: function (state) {
    return state.myDealer.dealerId
  },
  myDealerName: function (state) {
    return state.myDealer.dealerName
  },
  myDealerType: function (state) {
    return 'typeInfo' in state.myDealer ? state.myDealer.typeInfo.typeText : null
  },
  myDealerHasPendingRegistration: function (state) {
    return 'statusInfo' in state.myDealer ? !state.myDealer.statusInfo.isRegistered : null
  },
  iAmOwnerOfMyDealer: function (state) {
    return 'ownerInfo' in state.myDealer ? state.myDealer.ownerInfo.userId === state.myProfile.userId : null
  },
  myEmail: function (state) {
    return state.myProfile.email
  },
  myUserId: function (state) {
    return state.myProfile.userId
  },
  myProfilePictureUrl: function (state) {
    return state.myProfile.profilePictureUrl
  },
  mySites: function (state) {
    return state.mySites
  },
  statusGetMyDealer: function (state) {
    return state.status.getMyDealer
  },
  statusGetMyProfile: function (state) {
    return state.status.getMyProfile
  },
  statusUpdateMyProfile: function (state) {
    return state.status.updateMyProfile
  },
  statusChangeMyPassword: function (state) {
    return state.status.changeMyPassword
  },
  statusUploadMyAvatar: function (state) {
    return state.status.uploadMyAvatar
  },
  statusSendEmailChangeEmail: function () {
    return state.status.sendEmailChangeEmail
  }
}

// actions
const actions = {
  getMyProfile: function ({commit, dispatch}) {
    commit(GET_MYPROFILE_REQUEST)
    return new Promise((resolve, reject) => {
      user.getMyProfile().then(
        res => {
          commit(GET_MYPROFILE_SUCCESS, res.body[0])
          // if email is not verified, but logged in, which means the user got the password by checking the email
          // so, it is safe to change the verify status to verified.
          // but CHeKT support multiple emails, then it is not a safe operation anymore.
          if (!res.body[0]['is_verify']) {
            dispatch('updateMyEmailAsVerified')
          }
          dispatch('getUserInfo')
          resolve()
        },
        err => {
          commit(GET_MYPROFILE_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  updateMyProfile: function ({commit, dispatch}, {firstName, lastName}) {
    commit(UPDATE_MYPROFILE_REQUEST)
    return new Promise((resolve, reject) => {
      user.updateMyProfile({firstName, lastName}).then(
        res => {
          commit(UPDATE_MYPROFILE_SUCCESS)
          resolve()
        },
        err => {
          commit(UPDATE_MYPROFILE_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  updateMyEmailAsVerified: function ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      user.updateMyEmailAsVerified().then(
        res => {
          resolve()
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  },
  changeMyPassword: function ({commit, dispatch}, {password}) {
    commit(CHANGE_MYPASSWORD_REQUEST)
    return new Promise((resolve, reject) => {
      user.changeMyPassword({password}).then(
        res => {
          commit(CHANGE_MYPASSWORD_SUCCESS)
          resolve()
        },
        err => {
          commit(CHANGE_MYPASSWORD_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  uploadMyAvatar: function ({commit, dispatch}, {blobData, contentType}) {
    commit(UPLOAD_MYAVATAR_REQUEST)
    return new Promise((resolve, reject) => {
      let fileExtension = contentType.split('/')[1]
      user.getMyAvatarUploadUrl({fileExtension}).then(
        res => {
          let uploadUrl = res.body['url']
          common.put(uploadUrl, blobData, contentType).then(
            res => {
              commit(UPLOAD_MYAVATAR_SUCCESS)
              resolve()
            },
            err => {
              commit(UPLOAD_MYAVATAR_FAILURE)
              reject(new Error(err.statusText))
            }
          )
        }
      )
    })
  },
  changeMyEmail: function ({commit, dispatch}, {email}) {
    commit(SEND_EMAILCHANGE_EMAIL_REQUEST)
    return new Promise((resolve, reject) => {
      user.changeMyEmail({email}).then(
        res => {
          commit(SEND_EMAILCHANGE_EMAIL_SUCCESS)
          // console.log(res)
          resolve(res.body.message)
        },
        err => {
          commit(SEND_EMAILCHANGE_EMAIL_FAILURE)
          // console.log(err)
          reject(new Error(err.body.message))
        }
      )
    })
  },
  getMyDealer: function ({commit, dispatch}) {
    commit(GET_MYDEALER_REQUEST)
    return new Promise((resolve, reject) => {
      user.getMyDealer().then(
        res => {
          let dealerId = res.body[0]['dealer_id']
          // if email is not verified, but logged in, which means the user got the password by checking the email
          // so, it is safe to change the verify status to verified.
          // but CHeKT support multiple emails, then it is not a safe operation anymore.
          // if verify email and accept invitation is one queue action
          if (!!res.body[0]['is_registered'] && res.body[0]['invitation_status'] + '' === '1') {
            dispatch('acceptMyDealerInvitation', {
              dealerId: res.body[0]['dealer_id'],
              memberId: res.body[0]['user_id']
            })
          }
          dealer.getDealer({dealerId}).then(
            res => {
              commit(GET_MYDEALER_SUCCESS, res.body[0])
              resolve()
            },
            err => {
              commit(GET_MYDEALER_FAILURE)
              reject(new Error(err.statusText))
            }
          )
        },
        err => {
          commit(GET_MYDEALER_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getMySites: function ({commit, dispatch}) {
    commit(GET_MYSITES_REQUEST)
    return new Promise((resolve, reject) => {
      site.getMySites().then(
        res => {
          if (res.body.length) {
            commit(GET_MYSITES_SUCCESS, res.body)
            resolve()
          } else {
            commit(GET_MYSITES_FAILURE)
            reject(new Error('No my sites'))
          }
        },
        err => {
          commit(GET_MYSITES_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getMyMetadata: function ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      user.getMyMetadata().then(
        res => {
          resolve(res)
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  },
  createMyMetadata: function ({commit, dispatch}, metadata) {
    return new Promise((resolve, reject) => {
      user.createMyMetadata(metadata).then(
        res => {
          resolve()
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  },
  updateMyMetadata: function ({commit, dispatch}, metadata) {
    return new Promise((resolve, reject) => {
      user.updateMyMetadata(metadata).then(
        res => {
          resolve()
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  },
  deleteMyMetadata: function ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      user.deleteMyMetadata().then(
        res => {
          resolve()
        },
        err => {
          reject(new Error(err.statusText))
        }
      )
    })
  }
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [GET_MYPROFILE_REQUEST]: function (state) {
    state.status = {...state.status, 'getMyProfile': 'requested'}
  },
  [GET_MYPROFILE_SUCCESS]: function (state, data) {
    try {
      let profileInfo = {
        userId: data.user_id,
        mqttAccessToken: data.access_token,
        email: data.email,
        firstName: data.firstname,
        lastName: data.lastname,
        created: data.created,
        // isToResetPassword: !!data.is_reset_password, // TO BE DELETED
        isEmailVerified: data.is_verify,
        profilePictureUrl: data.provider_picture,
        isAdmin: data.role === 'admin'
      }
      state.myProfile = profileInfo
      state.status = {...state.status, 'getMyProfile': 'successful'}
    } catch (err) {
      Vue.logger.error('GET_MYPROFILE_SUCCESS: Failed')
      Vue.logger.error(err.message)
      state.status = {...state.status, 'getMyProfile': 'failed'}
    }
  },
  [GET_MYPROFILE_FAILURE]: function (state) {
    state.status = {...state.status, 'getMyProfile': 'failed'}
  },
  [GET_MYDEALER_REQUEST]: function (state) {
    state.status = {...state.status, 'getMyDealer': 'requested'}
  },
  [GET_MYDEALER_SUCCESS]: function (state, data) {
    try {
      let dealerType = data.type ? data.type : 0
      let dealerInfo = {
        dealerId: data.dealer_id,
        dealerName: data.company_name,
        profilePictureUrl: data.provider_picture,
        typeInfo: {
          type: dealerType,
          typeText: state.dealerTypeTextList[+dealerType]
        },
        ownerInfo: {
          userId: data.user_id,
          email: data.email,
          firstName: data.firstname,
          lastName: data.lastname
        },
        locationInfo: {
          address: (data.company_address2 ? data.company_address2 + ' ' : '') + data.company_address1,
          address1: data.company_address1,
          address2: data.company_address2,
          postalCode: data.company_zipcode,
          timezone: data.timezone,
          lat: data.lat,
          lng: data.lng
        },
        contactInfo: {
          phone: data.company_phone,
          email: data.company_email
        },
        statusInfo: {
          isDeleted: !!data.is_deleted,
          isRegistered: !!data.is_registered,
          isMonitoringBlocked: !!data.is_monitoring_block,
          createdDate: data.created ? new Date(data.created) : null,
          registeredDate: data.registered_time ? new Date(data.registered_time) : null,
          deletedDate: data.deleted_time ? new Date(data.deleted_time) : null
        },
        statistics: {
          totalSite: data.site_count ? data.site_count : 0,
          totalBridge: data.bridge_count ? data.bridge_count : 0,
          totalCamera: data.camera_count ? data.camera_count : 0,
          totalUser: data.user_count ? data.user_count : 0
        }
      }
      state.myDealer = dealerInfo
      state.status = {...state.status, 'getMyDealer': 'successful'}
    } catch (err) {
      Vue.logger.error('GET_MYDEALER_SUCCESS: Failed')
      Vue.logger.error(err.message)
      state.status = {...state.status, 'getMyDealer': 'failed'}
    }
  },
  [GET_MYDEALER_FAILURE]: function (state) {
    state.status = {...state.status, 'getMyDealer': 'failed'}
  },
  [GET_MYSITES_REQUEST]: function (state) {
    state.status = {...state.status, 'getMySites': 'requested'}
  },
  [GET_MYSITES_SUCCESS]: function (state, data) {
    try {
      let siteList = []
      data.map(site => {
        let siteData = {
          siteId: site['site_id'],
          siteName: site['name'],
          accountNumber: site['account_number'],
          blueprintUrl: site['blueprint_url'],
          // owner info
          siteOwnerUserId: site['user_id'],
          siteOwnerEmail: site['owner_email'],
          // location info
          siteAddress: (site['address2'] ? site['address2'] + ' ' : '') + site['address1'],
          siteLat: site['lat'],
          siteLng: site['lng'],
          timezone: site['timezone'] ? site['timezone'] : 'UTC'
        }
        siteList.push(siteData)
      })
      state.mySites = siteList
      state.status = {...state.status, 'getMySites': 'successful'}
    } catch (err) {
      Vue.logger.error('GET_MYSITES_SUCCESS: Failed')
      Vue.logger.error(err.message)
      state.status = {...state.status, 'getMySites': 'failed'}
    }
  },
  [GET_MYSITES_FAILURE]: function (state) {
    state.status = {...state.status, 'getMySites': 'failed'}
  },
  [UPDATE_MYPROFILE_REQUEST]: function (state) {
    state.status = {...state.status, 'updateMyProfile': 'requested'}
  },
  [UPDATE_MYPROFILE_SUCCESS]: function (state) {
    state.status = {...state.status, 'updateMyProfile': 'successful'}
  },
  [UPDATE_MYPROFILE_FAILURE]: function (state) {
    state.status = {...state.status, 'updateMyProfile': 'failed'}
  },
  [CHANGE_MYPASSWORD_REQUEST]: function (state) {
    state.status = {...state.status, 'changeMyPassword': 'requested'}
  },
  [CHANGE_MYPASSWORD_SUCCESS]: function (state) {
    state.status = {...state.status, 'changeMyPassword': 'successful'}
  },
  [CHANGE_MYPASSWORD_FAILURE]: function (state) {
    state.status = {...state.status, 'changeMyPassword': 'failed'}
  },
  [UPLOAD_MYAVATAR_REQUEST]: function (state) {
    state.status = {...state.status, 'uploadMyAvatar': 'requested'}
  },
  [UPLOAD_MYAVATAR_SUCCESS]: function (state) {
    state.status = {...state.status, 'uploadMyAvatar': 'successful'}
  },
  [UPLOAD_MYAVATAR_FAILURE]: function (state) {
    state.status = {...state.status, 'uploadMyAvatar': 'failed'}
  },
  [SEND_EMAILCHANGE_EMAIL_REQUEST]: function (state) {
    state.status = {...state.status, 'sendEmailChangeEmail': 'requested'}
  },
  [SEND_EMAILCHANGE_EMAIL_SUCCESS]: function (state) {
    state.status = {...state.status, 'sendEmailChangeEmail': 'successful'}
  },
  [SEND_EMAILCHANGE_EMAIL_FAILURE]: function (state) {
    state.status = {...state.status, 'sendEmailChangeEmail': 'failed'}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/myProfile.js